/**
 * ============================================================================
 * GENERATED (NOW MODIFIED) FILE - Created via: pnpm run generate:wetags
 * ============================================================================
 *
 * This file was generated by the wetag library generator.
 *
 * However, it has since been modified to allow location scoped methods and dynamic namespaces.
 * So update with the CLI at your own risk.
 * ============================================================================
 */

import { createNamespacedWetagHooksForOrg } from '@frontend/wetags';
import { DEFAULT_PAYMENTS_NAMESPACE } from './namespaces';
import type { PaymentsTags } from './tags';

export const PaymentsOrg = createNamespacedWetagHooksForOrg<PaymentsTags>(DEFAULT_PAYMENTS_NAMESPACE);
